import React, {
    Component,
} from 'react';
import ReactHighcharts from '../../../../CommonComponents/Highcharts';
import {
    computeChartStringKey,
} from './ProgressChartHelpers';
import OwnerDropdown from '../../OwnerDropdown/OwnerDropdownContainer';
import SplitTabs from '../../SplitTabs/SplitTabsContainer';
import Breakdown from '../Breakdown/BreakdownContainer';

export default class ProgressChartView extends Component {
    render() {
        const {
            isPrint,
            clientId,
            fpId,
            goalId,
            ownerIndex,
            breakdown,
            note,
            subgoalId,
            setSelectedOwnerIndex,
            chartData,
            hasChartData,
            principalName,
            spouseName,
            annualInsuranceCost,
            annualLTCCost,
            assetsToLiquidate,
            dailyBenefit,
        } = this.props;

        return <div className="progress-chart-container NewFinancialPlan_LongTermCareInsuranceProgressChart">
            <SplitTabs
                isPrint={isPrint}
                clientId={clientId}
                goalId={goalId}
                subgoalId={subgoalId}
                tabs={[]}
                leftChildren={
                    <div>
                        {!isPrint && <OwnerDropdown
                            clientId={clientId}
                            goalId={goalId}
                            principalName={principalName}
                            spouseName={spouseName}
                            setSelectedIndex={setSelectedOwnerIndex}
                        />}
                        {hasChartData && <ReactHighcharts
                            autoResize={true}
                            className="progress-chart"
                            container={computeChartStringKey(
                                ownerIndex.toString(),
                                `${subgoalId}`,
                                fpId,
                                clientId
                            )}
                            options={chartData}
                        />}
                    </div>
                }
                rightChildren={
                    <Breakdown
                        clientId={clientId}
                        goalId={goalId}
                        subgoalId={subgoalId}
                        annualInsuranceCost={annualInsuranceCost}
                        annualLTCCost={annualLTCCost}
                        assetsToLiquidate={assetsToLiquidate}
                        dailyBenefit={dailyBenefit}
                        note={note.Notes.find((note) => note.Name === "Level 1")}
                    />
                }
            />
        </div>;
    }
};
